import styled from 'styled-components';

export const FeaturesContainer = styled.section`
  background-color: #000000;
  min-height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 60px 0;
  
  @media (max-width: 768px) {
    padding: 40px 0;
  }
  
  @media (max-width: 480px) {
    padding: 30px 0;
  }
`;

export const FeaturesContent = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  position: relative;
  
  @media (max-width: 768px) {
    margin-bottom: 30px;
    justify-content: center;
  }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  color: #ffffff;
  font-weight: 300;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  
  strong {
    font-weight: 700;
  }
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 1.3;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const FeatureDescription = styled.p`
  font-size: 1rem;
  color: #cccccc;
  line-height: 1.6;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  width: 100%;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 25px;
  background: linear-gradient(135deg, rgba(255, 122, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 100%);
  border: 1px solid rgba(255, 122, 0, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    border-color: rgba(255, 122, 0, 0.4);
    background: linear-gradient(135deg, rgba(255, 122, 0, 0.15) 0%, rgba(0, 0, 0, 0.4) 100%);
  }
  
  @media (max-width: 768px) {
    padding: 25px 20px;
    text-align: center;
    align-items: center;
  }
  
  @media (max-width: 480px) {
    padding: 20px 15px;
  }
`;

export const FeatureTitle = styled.h3`
  font-size: 1.25rem;
  color: #ffffff;
  margin-bottom: 15px;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;


export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TitleArrow = styled.div`
  width: 24px;
  height: 24px;
  background-image: url('/src/assets/images/arrow-up-right.svg');
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 10px;
  transform: rotate(45deg);
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }
  
  @media (max-width: 480px) {
    width: 18px;
    height: 18px;
    margin-left: 6px;
  }
`;